import React from "react";
import PropTypes from "prop-types";
import {
  Paper,
  Typography,
  LinearProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";

// Ranked list/table card — customer lifetime-value leaderboard, coupon usage.
const LeaderboardCard = ({ title, rows = [], columns = [], loading }) => {
  return (
    <Paper sx={{ padding: "1rem" }}>
      <Typography sx={{ fontSize: "16px", fontWeight: 700, marginBottom: "1rem" }}>
        {title}
      </Typography>
      {loading && <LinearProgress />}
      {!loading && rows.length === 0 && (
        <Typography sx={{ color: "#6B7280", fontSize: "13px", padding: "2rem 0", textAlign: "center" }}>
          No data available for this range.
        </Typography>
      )}
      {!loading && rows.length > 0 && (
        <Table size="small">
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.key}>{col.label}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id || row.customer_id || row.coupon_id || index}>
                {columns.map((col) => (
                  <TableCell key={col.key}>
                    {col.format ? col.format(row[col.key], row) : row[col.key]}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      )}
    </Paper>
  );
};

LeaderboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  rows: PropTypes.array,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      format: PropTypes.func,
    }),
  ),
  loading: PropTypes.bool,
};

export default LeaderboardCard;
